/**
 * console-bus.ts — a one-listener signal to open the Assistant console pre-filled
 * with a prompt. Used by /trace "Replay" to send a past run's prompt back to the
 * console for editing-then-rerun (replay-after-edit). In-memory only; nothing leaves
 * the browser.
 */
type Listener = (prompt: string) => void;
let listener: Listener | null = null;

/** Open the console with `prompt` queued for editing (not auto-sent). */
export function requestConsole(prompt: string): void {
  listener?.(prompt);
}

/** The console subscribes once; returns an unsubscribe. */
export function onConsoleRequest(fn: Listener): () => void {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}
